// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import PDFPrintSettings from "@bg/App/Components/PdfSettings/PDFPrintSettings";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    wishList: getWishListState(state, state.pages.myListDetails.wishListId),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const MyListDetailsPDF: React.FC<Props> = ({ id, wishList }) => {
    if (!wishList.value && !wishList.isLoading) {
        return null;
    }
    return <PDFPrintSettings showUploadLogo={false} isQuote={false} id={wishList.id} showIncludePrice={true} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(MyListDetailsPDF),
    definition: {
        group: "XNGAGE" as any,
        displayName: "PDF Settings",
        icon: "Printer",
        allowedContexts: ["MyListsDetailsPage"],
    },
};

export default widgetModule;
